import request from '../utils/fetch'
export function addStore (data) {
  return request({
    url: '/admin/store/addStore',
    method: 'post',
    requestBody: 'body',
    loading: true,
    data: data
  })
}
export function getStoreList (data) {
  return request({
    url: '/admin/store/getStoreList',
    method: 'get',
    requestBody: 'query',
    loading: true,
    params: data
  })
}
export function changeStoreState (data) {
  return request({
    url: '/admin/store/changeStoreState',
    method: 'get',
    requestBody: 'query',
    loading: true,
    params: data
  })
}
export function changeRem (data) {
  return request({
    url: '/admin/store/changeRem',
    method: 'get',
    requestBody: 'query',
    loading: true,
    params: data
  })
}
export function goods2Rem (data) {
  return request({
    url: '/store/goods/goods2Rem',
    method: 'get',
    requestBody: 'query',
    loading: true,
    params: data
  })
}
export function getCommendStoreList (data) {
  return request({
    url: '/admin/store/getCommendStoreList',
    method: 'get',
    requestBody: 'query',
    loading: true,
    params: data
  })
}
export function commendStoreSort (data) {
  return request({
    url: '/admin/store/commendStoreSort',
    method: 'get',
    requestBody: 'query',
    loading: true,
    params: data
  })
}
export function store2NotRem (data) {
  return request({
    url: '/admin/store/store2NotRem',
    method: 'get',
    requestBody: 'query',
    loading: true,
    params: data
  })
}
export function getStoreGoodsList (data) {
  return request({
    url: '/app/goods/getStoreGoodsList',
    method: 'get',
    requestBody: 'query',
    loading: true,
    params: data
  })
}
export function getSecondTimeByAdmin (data) {
  return request({
    url: '/admin/storeActive/getSecondTimeByAdmin',
    method: 'get',
    requestBody: 'query',
    loading: true,
    params: data
  })
}
// /admin/storeActive/getSecondTimeByAdmin
export function getStoreInfo (data) {
  return request({
    url: '/admin/store/getStoreInfo',
    method: 'get',
    requestBody: 'query',
    loading: true,
    params: data
  })
}
export function changeGoodsFreight (data) {
  return request({
    url: '/admin/store/changeGoodsFreight',
    method: 'get',
    requestBody: 'query',
    loading: true,
    params: data
  })
}










